import clsx from "clsx";
import { FC } from "react";
import { TableOfContentItem } from "./type";
import { useTableOfContent } from "./useTableOfContent";

interface Props {
  isHomeHeader?: boolean;
  tableOfContent: TableOfContentItem[];
  body: string;
}

export const TableOfContent: FC<Props> = ({ tableOfContent, body, isHomeHeader }) => {
  const [idReading, timelineRef] = useTableOfContent(tableOfContent, body);

  return (
    <div
      className={clsx(
        "sticky h-[fit-content] flex-1 flex-col items-start gap-3",
        isHomeHeader ? "top-[100px]" : "top-[81px]",
      )}
    >
      <div className="mb-3 text-[22px] font-bold">目次</div>
      <div ref={timelineRef} className="relative max-h-[calc(100vh_-_57px_-_44px_-_24px_-_50px)] overflow-y-auto">
        {tableOfContent.map((item, index) => {
          return (
            <div id={`item-${item.id}`} key={item.id} className="relative pl-3">
              <div
                className={clsx(
                  "absolute left-2 h-full w-0.5 bg-[#d0e6e7]",
                  index === 0 ? "bottom-0 !h-3/6" : "",
                  index === tableOfContent.length - 1 ? "!h-[1em]" : "",
                )}
              ></div>
              <div
                className={clsx(
                  "absolute top-[0.9em] rounded-[50%] border-solid border-[#d0e6e7] bg-[#6bacb6]",
                  item.level === item.levels[1] ? "left-[5px] h-2 w-2 border-2" : "left-[3px] h-3 w-3 border-2",
                  idReading === item.id ? ["!left-[3px] h-3 w-3 border-2", "!bg-[#448089]"] : undefined,
                )}
              ></div>
              <div
                className={clsx(
                  "relative break-all rounded-md px-[15px] py-[5px] hover:text-black",
                  idReading === item.id ? "text-black" : "text-[#65717b]",
                )}
              >
                <a href={item.href}>{item.title}</a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
